import { requestStateData } from './requestStateData'
import { useStateData } from './useStateData'
import { SignupState } from '../types'

export const fetchPaths = () =>
  requestStateData(
    'paths',
    ({ signupSession: { instantInkService }, localization }: SignupState) =>
      instantInkService.fetchPaths(
        localization?.language,
        localization?.country
      )
  )

export const usePaths = () => useStateData('paths', fetchPaths, () => true)
